import {Component, OnInit, TemplateRef} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {ToastrService} from 'ngx-toastr';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {ExportService} from 'app/common/services/Export.service';
import {WarningInspection} from '../../../qrcode/warning-overflow/services/warning-inspection';
import {environment} from '../../../../../../environments/environment';
import {EvsAddressService} from '../../../../../common/services/EvsAddress.service';
import {WarningUserService} from '../../../qrcode/warning-overflow/services/warning-user.service';
import {WarningAutoService} from '../../../qrcode/warning-overflow/services/warning-auto.service';
import {CheckStampService} from '../../stamp_list/services/check-stamp.service';
import * as moment from 'moment';
import {BatchService} from '../../../qrcode/batchstamp/batch.service';
import { TranslateService } from '@ngx-translate/core';
import {saveAs} from 'file-saver/FileSaver';

declare function baseTracking(appId);

declare function enterScreenView(screenName: any, contentType: any, referrer: any);

declare function visibleContent(regionName: any, contentName: any, index: any);

declare function clickTracking(regionName: any, contentName: any, target: any, payload: any);

declare function alertMsg(alertType: any, alertMessage: any);

declare function searchEvent(keywords: any, params: any, order: any, sort: any)

declare var $: any;

@Component({
  selector: "app-error-stamp-scanning",
  templateUrl: "./error-stamp-scanning.component.html",
  styleUrls: ["./error-stamp-scanning.component.css"],
  providers: [WarningAutoService, WarningUserService, WarningInspection,CheckStampService],
})
export class ErrorStampScanningComponent implements OnInit {
  modalDetailWarningAutoRef: BsModalRef;
  modalReportWarningAutoRef: BsModalRef;
  activeTab = 1;
  formWarningAuto = this.fb.group({
    serial: null,
    province_from: null,
    province_to: null,
    status: null,
    time: null,
  });
  // canh bao tu dong
  queryWarningAuto: any;
  pageIndexWarningAuto = 1;
  pageSizeWarningAuto = 10;
  filterWarningAuto: any = {};
  data_warning_auto = [];
  total_warning_auto = 0;
  currentIdStamp: string = "";
  currentStamp: any = null;
  pageIndexDetailWarningAuto: number = 1;
  pageSizeDetailWarningAuto: number = 5;
  detail_warning_auto: any = [];
  total_detail_warning_auto: number = 0;
  noteReportWarningAuto: string = "";
  idReportWarningAuto: string = "";
  warningList = [];
  loadingAutoWarning: boolean = false;
  // cảnh báo từ kiểm tra thị trường
  queryInspection;
  pageIndexSpection = 1;
  pageSizeSpection = 10;
  data_spection = [];
  total_spection = 0;
  loadingInspection: boolean = false;
  // canh bao tu nguoi dung
  queryWarningUser: any;
  pageIndexWarningUser = 1;
  pageSizeWarningUser = 10;
  formWarningUser = this.fb.group({
    serial: "",
    agency: "",
    province: "",
    ward: "",
    time: "",
  });
  data_warning_user = [];
  total_warning_user = 0;
  loadingUserWarning: boolean = false;
  // end canh bao tu nguoi dung
  listBatches = [];
  data = [
    {
      id: 1,
      name: "lala",
    },
  ];
  lat = 21.053751;
  lng = 105.739419;
  markers = [
    {
      lat: 21.05133,
      lng: 105.734137,
      label: "Xuân Phương, Nam Từ Liêm, Hà Nội, Việt Nam",
      // canh bao tu kiem tra thi truong
      icon: {
        url: "https://image.flaticon.com/icons/svg/196/196759.svg",
        scaledSize: {
          height: 80,
          width: 30,
        },
      },
    },
    {
      lat: 21.055237,
      lng: 105.735958,
      label: "Gần chợ - Chợ đầu mối Minh Khai, QL32, Việt Nam",
      // canh bao tu nguoi dung
      icon: {
        url: "https://image.flaticon.com/icons/svg/1277/1277612.svg",
        scaledSize: {
          height: 80,
          width: 30,
        },
      },
    },
    {
      lat: 21.053751,
      lng: 105.739419,
      label: "3P3Q+CQ Minh Khai, Bắc Từ Liêm, Hà Nội, Việt Nam",
      // canh bao tu dong
      icon: {
        url: "https://image.flaticon.com/icons/svg/684/684908.svg",
        scaledSize: {
          height: 80,
          width: 30,
        },
      },
    },
  ];
  zoom = 15;
  cities = [];
  districts = [];
  tmpDistricts = [];
  disabledLog = false;
  constructor(
    private fb: FormBuilder,
    private checkStampService: CheckStampService,
    private warningAutoService: WarningAutoService,
    private warningUserService: WarningUserService,
    private warningInspection: WarningInspection,
    private exportService: ExportService,
    private addressService: EvsAddressService,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private batchService: BatchService,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    baseTracking(environment.appIdTracking);
    enterScreenView('qcheck_warning_auto', 'others', '')
    const that = this;
    $("#from1").select2({
      placeholder: this.translate.instant("DAI_LY_XUAT"),
      allowClear: true,
      ajax: {
        delay: 1000,
        url: `${environment.qrcode_url}/agencies/profile/all`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Access-Token")}`,
          "Content-Type": "application/json",
        },
        dataType: "json",
        data: function (params) {
          if (params.term) {
            return {
              name: params.term,
              page: 1,
              page_size: 50,
            };
          }
          return {
            page: 1,
            page_size: 50,
          };
        },
        processResults: function (data) {
          return {
            results: data.data.items.map((item) => {
              return {
                text: item.name,
                id: item.id,
              };
            }),
          };
        },
      },
    });
    $("#to1").select2({
      placeholder: this.translate.instant("DAI_LY_NHAN"),
      allowClear: true,
    });
    $("#from1").on("change", function (e) {
      $(".select2-selection__rendered").removeAttr("title");
      let id = $("#from1").val();
      if (id) {
        that.initChildrenAgencies(id);
      } else {
        $("#to1").select2({
          placeholder: that.translate.instant("DAI_LY_NHAN"),
          allowClear: true,
          width: "140px",
        });
      }
      $("#to1").val("").trigger("change");
    });
    $("#province_from").select2({
      placeholder: this.translate.instant("KHU_VUC_XUAT"),
      allowClear: true,
    });
    $("#province_to").select2({ placeholder: this.translate.instant("DEN_KHU_VUC"), allowClear: true });
    // canh bao tu kiem tra thi truong
    $("#agency2").select2({
      placeholder: this.translate.instant("CHON_DAI_LY_CAP_DUOI"),
      allowClear: true,
      ajax: {
        delay: 1000,
        url: `${environment.qrcode_url}/agencies`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Access-Token")}`,
          "Content-Type": "application/json",
        },
        dataType: "json",
        data: function (params) {
          if (params.term) {
            return {
              name: params.term,
              offset: 0,
              limit: 50,
            };
          }
          return {
            offset: 0,
            limit: 50,
          };
        },
        processResults: function (data) {
          return {
            results: data.data.items.map((item) => {
              return {
                text: item.name,
                id: item.id,
              };
            }),
          };
        },
      },
    });
    const area2 = $("#area2");
    const district2 = $("#district2");
    area2.select2({ placeholder: this.translate.instant("KHU_VUC"), allowClear: true });
    area2.on("select2:select", function (e) {
      $(".select2-selection__rendered").removeAttr("title");
      const id = e.target.value;
      that.getDistrict(id);
      district2.val(null).trigger("change");
    });
    district2.select2({ placeholder: this.translate.instant("QUAN_HUYEN_SELECT"), allowClear: true });
    // end canh bao bao tu kiem tra thi truong
    $("#Agency3").select2({
      placeholder: this.translate.instant("DAI_LY"),
      allowClear: true,
      ajax: {
        delay: 1000,
        url: `${environment.qrcode_url}/agencies/search/all`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Access-Token")}`,
          "Content-Type": "application/json",
        },
        dataType: "json",
        data: function (params) {
          if (params.term) {
            return {
              keyword: params.term,
              page: 1,
              page_size: 50,
            };
          }
          return {
            page: 1,
            page_size: 50,
          };
        },
        processResults: function (data) {
          return {
            results: data.data.items.map((item) => {
              let qrcode = item.qrCode ? " / " + item.qrCode : "";
              return {
                text: item.phoneNumber
                  ? item.name + " (" + item.phoneNumber + ")" + qrcode
                  : item.name + qrcode,
                id: item.id,
              };
            }),
          };
        },
      },
    });
    $("#errorType3").select2({ placeholder: this.translate.instant("LY_DO"), allowClear: true });
    $("#Area3").select2({ placeholder: this.translate.instant("TINH_THANH"), allowClear: true });
    $("#Area3").on("select2:select", function (e) {
      $(".select2-selection__rendered").removeAttr("title");
      const id = e.target.value;
      that.getDistrict(id);
    });
    $("#district3").select2({ placeholder: this.translate.instant("QUAN_HUYEN_SELECT"), allowClear: true });

    this.translate.onLangChange.subscribe(() => {
      $("#from1").select2({
        placeholder: this.translate.instant("DAI_LY_XUAT"),
        allowClear: true,
      });
      $("#to1").select2({
        placeholder: this.translate.instant("DAI_LY_NHAN"),
        allowClear: true,
      });
      $("#province_from").select2({
        placeholder: this.translate.instant("KHU_VUC_XUAT"),
        allowClear: true,
      });
      $("#province_to").select2({ placeholder: this.translate.instant("DEN_KHU_VUC"), allowClear: true });
      $("#agency2").select2({
        placeholder: this.translate.instant("CHON_DAI_LY_CAP_DUOI"),
        allowClear: true,
      });
      area2.select2({ placeholder: this.translate.instant("KHU_VUC"), allowClear: true });
      district2.select2({ placeholder: this.translate.instant("QUAN_HUYEN_SELECT"), allowClear: true });
      $("#Agency3").select2({
        placeholder: this.translate.instant("DAI_LY"),
        allowClear: true,
      });
      $("#errorType3").select2({ placeholder: this.translate.instant("LY_DO"), allowClear: true });
      $("#Area3").select2({ placeholder: this.translate.instant("TINH_THANH"), allowClear: true });
      $("#district3").select2({ placeholder: this.translate.instant("QUAN_HUYEN_SELECT"), allowClear: true });
    });

    // const agencyData = JSON.parse(localStorage.getItem('agencyId'));
    // // tslint:disable-next-line:prefer-const
    // if (agencyData) {
    //   const newOption = new Option(agencyData.name, agencyData.id, false, false);
    //   $('#from1').append(newOption).trigger('change');
    //   localStorage.removeItem('agencyId')
    // }
    this.warningList = [];
    const warningList = JSON.parse(localStorage.getItem("warningList"));
    if (warningList && warningList.warningList.length > 0) {
      this.warningList = warningList.warningList;
    }
    console.log(this.warningList);
    localStorage.removeItem("warningList");
    this.getFromArea();
    this.loadDataWarningAuto();

    this.activatedRoute.queryParams.subscribe((params: Params) => {
      if (params.tab != undefined) {
        this.activeTab = params.tab ? params.tab : 1;
        if (this.activeTab == 2) {
          this.loadInspection();
        }
        this.clearPosParam();
      }
    });

    this.loadDataWarningUser()
  }

  clearPosParam() {
    this.router.navigate(["."], { relativeTo: this.activatedRoute });
  }

  // ================= cảnh báo tràn hàng tự động ======================= //
  loadDataWarningAuto() {
    visibleContent('qcheck_warning_auto', 'warning_search', '');
    visibleContent('qcheck_warning_auto', 'warning_view', '')
    visibleContent('qcheck_warning_auto', 'warning_paging', '')
    let body: any = {
      page: this.pageIndexWarningAuto,
      pageSize: this.pageSizeWarningAuto,
    };
    if (this.filterWarningAuto.serial && this.filterWarningAuto.serial.trim()) {
      body.serial = this.filterWarningAuto.serial.trim().toUpperCase();
    }
    if ($("#from1").val()) {
      body.fromAgencyId = $("#from1").val();
    }
    if ($("#to1").val()) {
      body.toAgencyId = $("#to1").val();
    }
    if ($("#province_from").val()) {
      body.fromProvinceId = $("#province_from").val();
    }
    if ($("#province_to").val()) {
      body.toProvinceId = $("#province_to").val();
    }
    if ($("#time1").val()) {
      body.fromDate = $("#time1").val().split("-")[0].trim();
      body.toDate = $("#time1").val().split("-")[1].trim();
    }
    if (this.warningList.length > 0) {
      body.listWarningId = this.warningList;
    }
    this.loadingAutoWarning = true;
    this.warningAutoService.getList(body).subscribe(
      (res) => {
        if (res.code === 1) {
          this.data_warning_auto = res.data.items.map((item: any) => {
            let tmpItem: any = {
              id: item.id,
              fromAgency: item.fromAgency,
              fromProvince: item.fromProvince,
              fromDistrict: item.fromDistrict,
              fromAddress: item.fromAddress,
              time: item.time,
              report: item.report,
            };
            if (item.toAgency) {
              tmpItem.toAgency = item.toAgency;
              tmpItem.toProvince = item.toProvince;
              tmpItem.toDistrict = item.toDistrict;
              tmpItem.toAddress = item.toAddress;
              return tmpItem;
            } else {
              if (item.location && item.location.item) {
                tmpItem._toProvince = [];
                item.location.item.provinceIds.forEach((idProvince: number) => {
                  let foundCity = this.cities.find(
                    (city: any) => city.id == idProvince
                  );
                  if (foundCity) {
                    tmpItem._toProvince.push(foundCity.name);
                    tmpItem.toProvince = tmpItem._toProvince.join(",");
                    this.getTmpDistrict(foundCity.id).subscribe((res: any) => {
                      if (res.length) {
                        tmpItem._toDistrict = [];
                        item.location.item.districtIds.forEach(
                          (idDistrict: number) => {
                            let foundDistrict = res.find(
                              (dist: any) => dist.id == idDistrict
                            );

                            if (foundDistrict) {
                              tmpItem._toDistrict.push(foundDistrict.name);
                              tmpItem.toDistrict = tmpItem._toDistrict.join(
                                ","
                              );
                            }
                            tmpItem.toAddress = item.location.item.address[0];
                            return tmpItem;
                          }
                        );
                      }
                    });
                  }
                });
              }
            }

            return tmpItem;
          });
          this.total_warning_auto = res.data.totalElement;
          this.loadingAutoWarning = false;
          return;
        }
        this.data_warning_auto = [];
        this.total_warning_auto = 0;
        this.loadingAutoWarning = false;
      },
      (error) => {
        this.data_warning_auto = [];
        this.total_warning_auto = 0;
        this.loadingAutoWarning = false;
      }
    );
  }

  searchWarningAuto() {
    let body: any = {
    };
    if (this.filterWarningAuto.serial && this.filterWarningAuto.serial.trim()) {
      body.serial = this.filterWarningAuto.serial.trim().toUpperCase();
    }
    if ($("#from1").val()) {
      body.fromAgencyId = $("#from1").val();
    }
    if ($("#to1").val()) {
      body.toAgencyId = $("#to1").val();
    }
    if ($("#province_from").val()) {
      body.fromProvinceId = $("#province_from").val();
    }
    if ($("#province_to").val()) {
      body.toProvinceId = $("#province_to").val();
    }
    if ($("#time1").val()) {
      body.fromDate = $("#time1").val().split("-")[0].trim();
      body.toDate = $("#time1").val().split("-")[1].trim();
    }
    if (this.warningList.length > 0) {
      body.listWarningId = this.warningList;
    }
    this.pageIndexWarningAuto = 1;
    this.loadDataWarningAuto();
  }
  searchWarningAutoTracking() {
    let body: any = {
    };
    if (this.filterWarningAuto.serial && this.filterWarningAuto.serial.trim()) {
      body.serial = this.filterWarningAuto.serial.trim().toUpperCase();
    }
    if ($("#from1").val()) {
      body.fromAgencyId = $("#from1").val();
    }
    if ($("#to1").val()) {
      body.toAgencyId = $("#to1").val();
    }
    if ($("#province_from").val()) {
      body.fromProvinceId = $("#province_from").select2('data')[0]['text'].trim();
    }
    if ($("#province_to").val()) {
      body.toProvinceId = $("#province_to").select2('data')[0]['text'].trim();
    }
    if ($("#time1").val()) {
      body.fromDate = $("#time1").val().split("-")[0].trim();
      body.toDate = $("#time1").val().split("-")[1].trim();
    }
    if (this.warningList.length > 0) {
      body.listWarningId = this.warningList;
    }
    console.log(123123123);
    searchEvent(JSON.stringify(body), JSON.stringify(body), '', '')
    this.pageIndexWarningAuto = 1;
  }

  resetWarningAuto() {
    this.pageIndexWarningAuto = 1;
    $("#province_from").val("").trigger("change");
    $("#province_to").val("").trigger("change");
    $("#from1").val("").trigger("change");
    $("#to1").val("").trigger("change");
    $("#time1").val("");
    if (this.warningList.length > 0) {
      this.warningList = [];
    }

    this.filterWarningAuto = {};
    this.loadDataWarningAuto();
  }

  prePageWarningAuto() {
    if (this.pageIndexWarningAuto > 1) {
      this.pageIndexWarningAuto = this.pageIndexWarningAuto - 1;
      this.loadDataWarningAuto();
    }
  }

  lastPageWarningAuto() {
    if (
      this.pageIndexWarningAuto * this.pageSizeWarningAuto <
      this.total_warning_auto
    ) {
      this.pageIndexWarningAuto = this.pageIndexWarningAuto + 1;
      this.loadDataWarningAuto();
    }
  }

  inputPageWarningAuto(event) {
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndexWarningAuto) {
      this.pageIndexWarningAuto = page;
      this.loadDataWarningAuto();
    }
  }

  showModalDetailWarningAuto(template: TemplateRef<any>, idStamp: string) {
    visibleContent('qcheck_warning_auto', 'form_warning_stamp', '')
    this.currentIdStamp = idStamp;
    this.loadDataDetailWarningAuto(idStamp);
    this.modalDetailWarningAutoRef = this.modalService.show(template);
  }

  loadDataDetailWarningAuto(idStamp: string) {
    let query = {
      page: this.pageIndexDetailWarningAuto,
      pageSize: this.pageSizeDetailWarningAuto,
    };
    this.warningAutoService.getDetail(idStamp, query).subscribe((res: any) => {
      if (res.code === 1) {
        this.total_detail_warning_auto = res.data.totalElement;
        this.detail_warning_auto = res.data.items.map(
          (item: any, index: number) => {
            return {
              stt: index + 1,
              idStart: item.idStart,
              idEnd: item.idEnd,
              serialStart: this.formatSerial(item.idStart, item.prefix),
              serialEnd: this.formatSerial(item.idEnd, item.prefix),
              bundleType: item.bundleType,
              product: item.product,
              count: item.idEnd - item.idStart + 1,
            };
          }
        );
      }
    });
  }

  showModalReportWarningAuto(template: TemplateRef<any>, warning: any) {
    clickTracking('qcheck_warning_auto', 'agency_report', 'form_agency_report', '');
    visibleContent('qcheck_warning_auto', 'form_agency_report', '');
    if (this.idReportWarningAuto != warning.id) {
      this.currentStamp = warning;
      this.currentStamp.fromAddress = warning.fromAddress
        ? warning.fromAddress
        : "";
      this.currentStamp.fromWard = warning.fromWard ? warning.fromWard : "";
      this.currentStamp.fromDistrict = warning.fromDistrict
        ? warning.fromDistrict
        : "";
      this.currentStamp.fromProvince = warning.fromProvince
        ? warning.fromProvince
        : "";
      this.currentStamp._fromAddress = (
        this.currentStamp.fromAddress +
        " " +
        this.currentStamp.fromWard +
        " " +
        this.currentStamp.fromDistrict +
        ", " +
        this.currentStamp.fromProvince
      ).trim();
      this.idReportWarningAuto = warning.id;
      this.noteReportWarningAuto = "";
    }

    this.modalReportWarningAutoRef = this.modalService.show(template);
  }

  submitNoteReportWarningAuto() {
    clickTracking('form_agency_report', 'report', 'qcheck_warning_auto', '');
    let body: any = {};
    if (this.idReportWarningAuto) {
      body.warningId = this.idReportWarningAuto;
    }
    if (this.noteReportWarningAuto && this.noteReportWarningAuto.trim()) {
      body.note = this.noteReportWarningAuto.trim();
    } else {
      this.noteReportWarningAuto = "";
      this.toastr.warning("Note không để trống", "Thông báo:", {
        timeOut: 4000,
        positionClass: "toast-top-right",
      });
      return;
    }

    if (body.warningId && body.note) {

      this.warningAutoService.reportAgency(body).subscribe((res: any) => {
        if (res.code === 1) {
          this.toastr.success("Báo cáo thành công", "Thông báo:", {
            timeOut: 4000,
            positionClass: "toast-top-right",
          });
          this.idReportWarningAuto = "";
          this.noteReportWarningAuto = "";
          this.modalReportWarningAutoRef.hide();
          this.loadDataWarningAuto();
        } else {
          this.toastr.error(res.message, "Lỗi:", {
            timeOut: 4000,
            positionClass: "toast-top-right",
          });
        }
      }, err => {
        this.toastr.error(err.message, "Lỗi:", {
          timeOut: 4000,
          positionClass: "toast-top-right",
        });
      });
    }
  }

  prePageDetailWarningAuto() {
    if (this.pageIndexDetailWarningAuto > 1) {
      this.pageIndexDetailWarningAuto = this.pageIndexDetailWarningAuto - 1;
      this.loadDataDetailWarningAuto(this.currentIdStamp);
    }
  }

  lastPageDetailWarningAuto() {
    if (
      this.pageIndexDetailWarningAuto * this.pageSizeDetailWarningAuto <
      this.total_detail_warning_auto
    ) {
      this.pageIndexDetailWarningAuto = this.pageIndexDetailWarningAuto + 1;
      this.loadDataDetailWarningAuto(this.currentIdStamp);
    }
  }

  inputPageDetailWarningAuto(event) {
    const page = parseInt(event.target.value);
    if (
      page % 1 === 0 &&
      page > 0 &&
      page !== this.pageIndexDetailWarningAuto
    ) {
      this.pageIndexDetailWarningAuto = page;
      this.loadDataDetailWarningAuto(this.currentIdStamp);
    }
  }

  initChildrenAgencies(idAgency: number) {
    if (idAgency) {
      $("#to1").select2({
        placeholder: "Đại lý nhận",
        width: "140px",
        allowClear: true,
        ajax: {
          delay: 1000,
          url: `${environment.qrcode_url}/agencies/${idAgency}/children`,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Access-Token")}`,
            "Content-Type": "application/json",
          },
          dataType: "json",
          data: function (params) {
            if (params.term) {
              return {
                name: params.term,
                page: 1,
                page_size: 50,
              };
            }
            return {
              page: 1,
              page_size: 50,
            };
          },
          processResults: function (data) {
            return {
              results: data.data.items.map((item) => {
                return {
                  text: item.name,
                  id: item.id,
                };
              }),
            };
          },
        },
      });
    }
  }

  // ================= end cảnh báo tràn hàng tự động =================== //

  // ================= canh bao tu kiem tra thi truong ================== //
  loadInspection() {
    visibleContent('qcheck_warning_market_view', 'warning_market_search', '');
    visibleContent('qcheck_warning_market_view', 'warning_market_view', '')
    visibleContent('qcheck_warning_market_view', 'warning_market_paging', '')
    let opt: any = {
      page: this.pageIndexSpection,
      page_size: this.pageSizeSpection,
    };
    if ($("#serial2").val() && $("#serial2").val().trim() !== "") {
      opt.serial = $("#serial2").val().trim().toUpperCase();
    }
    if ($("#agency2").val()) {
      opt.agencyId = $("#agency2").val();
    }
    if ($("#area2").val()) {
      opt.provinceId = $("#area2").val();
    }
    if ($("#district2").val()) {
      opt.districtId = $("#district2").val();
    }
    if ($("#time2").val()) {
      opt.from = $("#time2").val().split("-")[0];
      opt.to = $("#time2").val().split("-")[1];
    }
    this.loadingInspection = true;
    this.warningInspection.getList(opt).subscribe(
      (res) => {
        if (res.code === 1) {
          this.total_spection = res.data.totalElement;
          this.data_spection = res.data.items;
          this.loadingInspection = false;
          return;
        }
        this.total_spection = 0;
        this.data_spection = [];
        this.loadingInspection = false;
      },
      (error) => {
        this.total_spection = 0;
        this.data_spection = [];
        this.loadingInspection = false;
      }
    );
  }

  searchInspection() {
    this.pageIndexSpection = 1;
    this.loadInspection();
  }

  resetInspection() {
    $("#serial2").val("").trigger("change");
    $("#agency2").val([]).trigger("change");
    $("#area2").val("").trigger("change");
    $("#district2").val("").trigger("change");
    $("#time2").val("").trigger("change");
    this.pageIndexSpection = 1;
    this.loadInspection();
  }

  prePageSpection() {
    this.pageIndexSpection = this.pageIndexSpection - 1;
    this.loadInspection();
  }

  lastPageSpection() {
    if (this.pageIndexSpection * this.pageIndexSpection < this.total_spection) {
      this.pageIndexSpection = this.pageIndexSpection + 1;
      this.loadInspection();
    }
  }

  inputPageSpection(event) {
    // tslint:disable-next-line:radix
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndexSpection) {
      this.pageIndexSpection = page;
      this.loadInspection();
    }
  }

  // ================= end canh bao tu kiem tra thi truong ================== //

  // ================= canh bao tu nguoi dung ============= //

  loadDataWarningUser() {
    visibleContent('qcheck_warning_user_view', 'warning_user_search', '');
    visibleContent('qcheck_warning_user_view', 'warning_user_view', '')
    visibleContent('qcheck_warning_user_view', 'warning_user_paging', '')
    let query: any = {
      serial:
        $("#serial3").val() && $("#serial3").val().trim() !== ""
          ? $("#serial3").val().trim().toUpperCase()
          : "",
      cityId: $("#Area3").val() || "",
      address: $("#address3").val() || "",
      errorType: $("#errorType3").val() || "",
      fromDate: "",
      toDate: "",
      page: this.pageIndexWarningUser,
      size: this.pageSizeWarningUser,
    };
    let time = $("#time3").val();
    if (time) {
      query.fromDate = time.split("-")[0].split("/").join("-").trim();
      query.toDate = time.split("-")[1].split("/").join("-").trim();
    }

    this.loadingUserWarning = true;
    this.checkStampService.getScanErr(query).subscribe(
      (res) => {
        if (res.code === 1) {
          if (
            res.data.items !== null ||
            (res.data.items && res.data.items.length > 0)
          ) {
            this.data_warning_user = res.data.items;
            this.total_warning_user = res.data.pagination.totalElements;
            this.loadingUserWarning = false;
            return;
          } else {
            this.data_warning_user = [];
            this.loadingUserWarning = false;
            this.total_warning_user = 0;
          }
        }
        this.data_warning_user = [];
        this.loadingUserWarning = false;
        this.total_warning_user = 0;
      },
      (error) => {
        this.data_warning_user = [];
        this.total_warning_user = 0;
        this.loadingUserWarning = false;
      }
    );
  }

  searchWarningUser() {
    this.pageIndexWarningUser = 1;
    this.loadDataWarningUser();
  }

  resetWarningUser() {
    this.pageIndexWarningUser = 1;
    this.formWarningUser.reset();
    $("#serial3").val("").trigger("change");
    $("#Area3").val("").trigger("change");
    $("#address3").val("").trigger("change");
    $("#errorType3").val("").trigger("change");
    $("#time3").val("").trigger("change");
    this.loadDataWarningUser();
  }

  prePageWarningUser() {
    if (this.pageIndexWarningUser > 1) {
      this.pageIndexWarningUser = this.pageIndexWarningUser - 1;
      this.loadDataWarningUser();
    }
  }

  lastPageWarningUser() {
    if (
      this.pageIndexWarningUser * this.pageSizeWarningUser <
      this.total_warning_user
    ) {
      this.pageIndexWarningUser = this.pageIndexWarningUser + 1;
      this.loadDataWarningUser();
    }
  }

  inputPageWarningUser(event) {
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndexWarningUser) {
      this.pageIndexWarningUser = page;
      this.loadDataWarningUser();
    }
  }

  // ================= end canh bao tu nguoi dung ========= //
  changeTab(event) {
    this.activeTab = event;
    if (event === 1) {
      this.resetWarningAuto();
    }
    if (event === 2) {
      enterScreenView('qcheck_warning_market_view', 'others', '')
      this.resetInspection();
    }
    if (event === 3) {
      enterScreenView('qcheck_warning_user_view', 'others', '')
      this.resetWarningUser();
    }
    this.districts = [];
  }

  onMouseOver(infoWindow, gm) {
    if (gm.lastOpen != null) {
      gm.lastOpen.close();
    }

    gm.lastOpen = infoWindow;

    infoWindow.open();
  }

  onMouseOut(infoWindow, gm) {
    infoWindow.close();
  }

  getDate(date) {
    const today = new Date(date);
    let dd: any = today.getDate();
    let mm: any = today.getMonth() + 1;
    const yyyy = today.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    return yyyy + "-" + mm + "-" + dd;
  }

  getFromArea() {
    this.cities = [];
    this.addressService.getCities().subscribe((res) => {
      if (res.status === 200) {
        const data = res.data.cities;
        this.cities = data;
      }
    });
  }

  getDistrict(id: number) {
    const query = {
      city_id: id,
    };
    this.addressService.getDistrict(query).subscribe((res) => {
      if (res.status === 200) {
        const citiesList = [];
        const items = res.data.districts;
        items.map((item) => {
          citiesList.push({
            label: item.name,
            id: item.id,
          });
        });
        this.districts = citiesList;
      }
    });
  }

  getTmpDistrict(id: number) {
    const query = {
      city_id: id,
    };
    return this.addressService.getDistrict(query).map((res) => {
      if (res.status === 200) {
        return res.data.districts;
      }
    });
  }

  formatSerial(id: any, prefix: string) {
    let serial_f: string = "";
    id = id.toString();
    if (id && prefix) {
      let pad = "000000";
      let serial = pad.substring(0, 6 - id.length) + id;
      serial_f = prefix + "-" + serial;
    }
    return serial_f;
  }

  // search serial
  searchInfoSerial(code: string) {
    this.router.navigate(['/find-stamp'], {queryParams: {code}});
    if (this.modalDetailWarningAutoRef) {
      this.modalDetailWarningAutoRef.hide();
    }
  }

  // Export Alert
  public messageExport: any = '';
  bsModalDownload: BsModalRef;
  showDownloadWarningOverflow(templateDownload) {
    this.bsModalDownload = this.modalService.show(templateDownload);
  }

  downloadWarningAuto() {
    this.disabledLog = true
    const timePicker = $('.timePicker2');
    let timeData = {
      startDate: timePicker.val().split('-')[0]
        ? timePicker.val().split('-')[0].trim()
        : '',
      endDate: timePicker.val().split('-')[1]
        ? timePicker.val().split('-')[1].trim()
        : '',
    }
    if (!timePicker.val()) {
      this.toastr.warning('Bạn chưa chọn thời gian', 'Thông báo:', {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      });
    } else {
      this.warningAutoService.getTokenDownloadWarningAuto(timeData).subscribe((data) => {
        data._body.text().then((val) => {
          console.log('data', val)
          if (/^[\],:{}\s]*$/.test(val.replace(/\\["\\\/bfnrtu]/g, '@').
            replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').
            replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {

            this.toastr.warning(`${JSON.parse(val).message}`, 'Cảnh báo', {
              timeOut: 3000,
              positionClass: 'toast-top-right',
            });
            //the json is ok
            console.log(1111)
          } else {
            console.log(22222)
            this.warningAutoService.saveToFileSystem(data, 'application/vnd.ms-excel', 'Danh sách cảnh báo tự dộng.xlsx')
            //the json is not ok
          }
        })
        this.disabledLog = false

      }, (error) => {
        this.disabledLog = false
      });
    }

  }


  downloadInspection() {
    this.disabledLog = true
    const timePicker = $('.timePicker2');
    let timeData = {
      startDate: timePicker.val().split('-')[0]
        ? timePicker.val().split('-')[0].trim()
        : '',
      endDate: timePicker.val().split('-')[1]
        ? timePicker.val().split('-')[1].trim()
        : '',
    }
    if (!timePicker.val()) {
      this.toastr.warning('Bạn chưa chọn thời gian', 'Thông báo:', {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      });
    } else {
      this.warningInspection.getTokenDownloadInspection(timeData).subscribe((data) => {
        data._body.text().then((val) => {
          console.log('data', val)
          if (/^[\],:{}\s]*$/.test(val.replace(/\\["\\\/bfnrtu]/g, '@').
            replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').
            replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {

            this.toastr.warning(`${JSON.parse(val).message}`, 'Cảnh báo', {
              timeOut: 3000,
              positionClass: 'toast-top-right',
            });
            //the json is ok
            console.log(1111)
          } else {
            console.log(22222)
            this.warningAutoService.saveToFileSystem(data, 'application/vnd.ms-excel', 'Danh sách kiểm tra thị trường.xlsx')
            //the json is not ok
          }
        })
        this.disabledLog = false

      }, (error) => {
        this.disabledLog = false
      });
    }

  }
  // Export Warning User
  downloadWarningUser() {
    this.disabledLog = true
    const timePicker = $('.timePicker2');
    let timeData = {
      startDate: timePicker.val().split('-')[0]
        ? timePicker.val().split('-')[0].trim()
        : '',
      endDate: timePicker.val().split('-')[1]
        ? timePicker.val().split('-')[1].trim()
        : '',
    }
    if (!timePicker.val()) {
      this.toastr.warning('Bạn chưa chọn thời gian', 'Thông báo:', {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      });
    } else {
      this.warningUserService.getTokenDownloadWarningUser(timeData).subscribe((data) => {
        data._body.text().then((val) => {
          console.log('data', val)
          if (/^[\],:{}\s]*$/.test(val.replace(/\\["\\\/bfnrtu]/g, '@').
            replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').
            replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {

            this.toastr.warning(`${JSON.parse(val).message}`, 'Cảnh báo', {
              timeOut: 3000,
              positionClass: 'toast-top-right',
            });
            //the json is ok
            console.log(1111)
          } else {
            console.log(22222)
            this.warningUserService.saveToFileSystem(data, 'application/vnd.ms-excel', 'Danh sách cảnh báo từ người dùng.xlsx')
            //the json is not ok
          }
        })
        this.disabledLog = false

      }, (error) => {
        this.disabledLog = false
      });
    }
  }

  // exportAlert(type: string, tab: any) {
  //   console.log('tab', this.activeTab)
  //   this.messageExport = '';
  //   $('.stampBoxStampAlertAdd').css('opacity', '0');
  //   const body = {
  //     exportTypeEnum: null,
  //     fields: null
  //   };
  //   const query: any = {};
  //   if (tab == 1) {
  //     if (this.filterWarningAuto.serial && this.filterWarningAuto.serial.trim()) {
  //       query.serial = this.filterWarningAuto.serial.trim().toUpperCase();
  //     }
  //     if ($('#from1').val()) {
  //       query.fromAgencyId = $('#from1').val();
  //     }
  //     if ($('#to1').val()) {
  //       query.toAgencyId = $('#to1').val();
  //     }
  //     if ($('#province_from').val()) {
  //       query.fromProvinceId = $('#province_from').val();
  //     }
  //     if ($('#province_to').val()) {
  //       query.toProvinceId = $('#province_to').val();
  //     }
  //     if ($('#time1').val()) {
  //       query.fromDate = $('#time1').val().split('-')[0].trim();
  //       query.toDate = $('#time1').val().split('-')[1].trim();
  //     }
  //     if (this.warningList.length > 0) {
  //       query.listWarningId = this.warningList;
  //     }
  //   } else if (tab == 2) {
  //     if ($('#serial2').val() && $('#serial2').val().trim() !== '') {
  //       query.serial = $('#serial2').val().trim().toUpperCase();
  //     }
  //     if ($('#agency2').val()) {
  //       query.agencyId = $('#agency2').val();
  //     }
  //     if ($('#area2').val()) {
  //       query.provinceId = $('#area2').val();
  //     }
  //     if ($('#district2').val()) {
  //       query.districtId = $('#district2').val();
  //     }
  //     if ($('#time2').val()) {
  //       query.from = $('#time2').val().split('-')[0];
  //       query.to = $('#time2').val().split('-')[1];
  //     }
  //   } else {
  //     query.keySearch = $('#serial3').val() && $('#serial3').val().trim() !== '' ? $('#serial3').val().trim().toUpperCase() : ''
  //     query.agency = $('#Agency3').val() || ''
  //     query.province = $('#Area3').val() || ''
  //     query.from = ''
  //     query.to = ''
  //     const time = $('#time3').val();
  //     if (time) {
  //       query.from = time.split('-')[0].split('/').join('-').trim();
  //       query.to = time.split('-')[1].split('/').join('-').trim();
  //     }
  //   }
  //   body.exportTypeEnum = type;
  //   body.fields = query
  //   this.exportService
  //     .exportReport(body)
  //     .subscribe((res) => {
  //       if (res.code == 1) {
  //         this.messageExport = 'Hệ thống đang xử lý xuất file, vui lòng chờ trong giây lát và nhận kết quả trong mục thông báo.';
  //         $('.stampBoxStampAlertAdd').css('opacity', '1');
  //         setTimeout(() => {
  //           $('.stampBoxStampAlertAdd').css('opacity', '0');
  //         }, 5000);
  //       } else {
  //         $('.stampBoxStampAlertAdd').css('opacity', '0');
  //         this.toastr.error(res.message, 'Thông báo', {
  //           timeOut: 3000,
  //           positionClass: 'toast-bottom-right'
  //         })
  //       }
  //     }, (error) => {
  //       this.toastr.error(error.message, 'Thông báo', {
  //         timeOut: 3000,
  //         positionClass: 'toast-bottom-right'
  //       })
  //     });
  // }
  // Hàm chuyển object thành query string
  toQueryString(obj) {
    var str = [];
    for (var key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] !== null && obj[key] !== undefined) {
        str.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]));
      }
    }
    return str.join('&');
  }
  exportReport() {
    // const [start, end] = this.warningFilter.time;
    // const maxRange = moment(start).add(3, 'months');
    //
    // if (moment(end).isAfter(maxRange)) {
    //   // Hiển thị cảnh báo hoặc reset lại
    //   this.messageExport = 'Chỉ được chọn tối đa trong vòng 3 tháng!';
    //   $('.stampBoxStampAlertAdd2').css('display', 'block');
    //   setTimeout(() => {
    //     $('.stampBoxStampAlertAdd2').css('display', 'none');
    //   }, 5000);
    //
    //   return;
    // }


    let query: any = {
      serial:
        $("#serial3").val() && $("#serial3").val().trim() !== ""
          ? $("#serial3").val().trim().toUpperCase()
          : "",
      cityId: $("#Area3").val() || "",
      address: $("#address3").val() || "",
      errorType: $("#errorType3").val() || "",
      fromDate: "",
      toDate: "",
      page: this.pageIndexWarningUser,
      size: this.pageSizeWarningUser,
    };
    let time = $("#time3").val();
    if (time) {
      query.fromDate = time.split("-")[0].split("/").join("-").trim();
      query.toDate = time.split("-")[1].split("/").join("-").trim();
    }
    var queryString = this.toQueryString(query);
    var url = environment.api_evs + '/qr-core-aps/scan-errors/export?' + queryString;
    this.batchService.downloadExcelExample2(url).subscribe((res) => {
      saveAs(res, `Baocao.xlsx`)
    }, error => {
      this.toastr.warning(error.message, 'Thông báo', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      })
    })

    // this.exportService.exportInventoryBatchExport(data).subscribe((res) => {
    //   if (res.code == 1) {
    //     this.messageExport = 'Hệ thống đang xử lý xuất file, vui lòng chờ trong giây lát và nhận kết quả trong mục thông báo.';
    //     $('.stampBoxStampAlertAdd').css('opacity', '1');
    //     setTimeout(() => {
    //       $('.stampBoxStampAlertAdd').css('opacity', '0');
    //     }, 5000);
    //   } else {
    //     this.toastr.error(res.message, 'Thông báo', {
    //       timeOut: 4000,
    //       positionClass: 'toast-bottom-right'
    //     })
    //   }
    // }, (error) => {
    //   console.log('123123', 123123)
    //   this.toastr.error(error.message, 'Thông báo', {
    //     timeOut: 4000,
    //     positionClass: 'toast-bottom-right'
    //   })
    // });
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/logs/tab2/error-stamp-scanning.component.ts